

















import Vue from "vue";
import { Header } from "@/components/MyTabs.vue";
import Overview from "./StorageInfo/Overview.vue";
import { axios } from "../../plugins";
import { uuid } from "../../utils/uuid";
import { eventBus } from "../../utils/event";
const Tabs: Header[] = [{ label: "概览", name: "tab1", uuid: uuid() }];

export default Vue.extend({
  name: "TaskInfo",
  components: { Overview },
  props: { projectId: { type: String } },
  data() {
    return {
      Tabs,
      dialog: false,
      tabActive: "tab1",
      storageName: "",
      storageData: null as any
      // statusEnum
    };
  },
  deactivated() {
    this.dialog = false;
    this.tabActive = "tab1";
  },
  watch: {
    tabActive(val) {
      const tab = Tabs.find(item => item.name === val);
      eventBus.$emit("setBeard", { name: (tab as Header).label });
    }
  },
  methods: {
    show(name: any) {
      this.storageName = name;
      this.getStorageData(name, this.projectId).then(() => {
        this.dialog = true;
      });
    },
    close() {
      this.dialog = false;
      // 此项设置会触发 tabActive watch
      // 导致 面包屑 触发 setBeard
      // 目前是在面包屑上加 $nextTick
      this.tabActive = "tab1";
    },
    getStorageData(name: string, projectId: string) {
      return axios.get(`/storage/pvc/${projectId}/${name}`).then(res => {
        const data = res.data.data;
        this.storageData = {
          name: data.metadata.name,
          description:
            data.metadata.annotations &&
            data.metadata.annotations["appmgr.object.description"],
          capacity: data.status.capacity?.storage,
          model: data.status.accessModes && data.status.accessModes[0],
          storageClassName: data.spec.storageClassName,
          volumeMode: data.spec.volumeMode,
          volumeName: data.spec.volumeName,
          createBy:
            data.metadata.annotations &&
            data.metadata.annotations["appmgr.object.createBy"],
          createTime: data.metadata.creationTimestamp
        };
      });
    }
  }
});
